import { render, staticRenderFns } from "./customerServiceEmployeeStatistics.vue?vue&type=template&id=2be8f6b2&scoped=true&"
import script from "./customerServiceEmployeeStatistics.vue?vue&type=script&lang=js&"
export * from "./customerServiceEmployeeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceEmployeeStatistics.vue?vue&type=style&index=0&id=2be8f6b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8f6b2",
  null
  
)

component.options.__file = "customerServiceEmployeeStatistics.vue"
export default component.exports